module.exports = __webpack_public_path__ + "static/media/b3.2aa42523.png";